import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        'flex h-10 w-full rounded-md border border-white/10 bg-eol-black/40 px-3 py-2 text-sm text-eol-white placeholder:text-eol-desc focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-eol-pink/50 focus-visible:border-eol-pink/40 disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';

export { Input };
